export default "__VITE_ASSET__weXXceMt__"